<template>
  <div>
    <form @submit.prevent="submit">
      <h2>{{ $t("global.select-a-certificate-type") }}</h2>
      <div class="ssl-packages">
        <div v-if="!cert.isMultiDomain && !cert.isWildcard">
          <h4>{{ $t("global.single-domain") }}</h4>
          <div v-for="pack in singleDomainPackages" :key="pack.id" class="ssl-package">
            <FormRadio
              v-if="pack.id"
              class="mr-2"
              :label="`${pack.name} ($${pack.annualFee})`"
              name="package_id"
              :value="pack.id"
              @change="packageChange"
            />
          </div>
        </div>
        <div v-else-if="cert.isMultiDomain">
          <h4>{{ $t("global.multi-domains") }}</h4>
          <div v-for="pack in multipleDomainPackages" :key="pack.id" class="ssl-package">
            <FormRadio
              v-if="pack.id"
              class="mr-2"
              :label="pack.name"
              name="package_id"
              :value="pack.id"
              @change="packageChange"
            />
          </div>
        </div>
        <div v-else-if="cert.isWildcard">
          <h4>{{ $t("global.wildcard") }}</h4>
          <div v-for="pack in wildcardDomainPackages" :key="pack.id" class="ssl-package">
            <FormRadio
              v-if="pack.id"
              class="mr-2"
              :label="pack.name"
              name="package_id"
              :value="pack.id"
              @change="packageChange"
            />
          </div>
        </div>
      </div>
      <div class="form-buttons">
        <Btn variant="primary" type="submit" :disabled="!isSubmittable()" :loading="loading">
          {{ $t("global.order") }}
        </Btn>
      </div>
    </form>
  </div>
</template>
<script>
import { computed, reactive, ref } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import FormRadio from "@/components/display/form/FormRadio";
import store from "@/store";

export default {
  name: "CertificateAddWithCertForm",
  components: {
    Btn,
    FormRadio,
  },
  props: {
    cert: {
      type: Object,
      required: true,
    },
    packages: {
      type: Object,
      required: true,
    },
    onChange: Function,
  },
  setup(props, { root }) {
    const singleDomainCodes = ["positivessl", "truebizid", "truebusinessidev"];
    const multipleDomainCodes = ["positivemdcssl", "truebusinessidevmd"];
    const wildcardDomainCodes = ["positivesslwildcard"];

    const getPackage = (code) => props.packages.list.find((pack) => pack.sslProductCode === code);
    const isSubmittable = () => fields.package_id !== 0;

    const singleDomainPackages = computed(() => singleDomainCodes.map(getPackage));
    const multipleDomainPackages = computed(() => multipleDomainCodes.map(getPackage));
    const wildcardDomainPackages = computed(() => wildcardDomainCodes.map(getPackage));

    const loading = ref(false);
    const errors = ref(null);
    const fields = reactive({
      package_id: 0,
    });

    const packageChange = (res) => {
      fields.package_id = props.packages.list.find((pack) => Number(res.value) === pack.id).id;
      props.onChange("package", fields.package_id);
    };

    const submit = () => {
      errors.value = null;
      loading.value = true;
      const data = {
        distinguished_name: { ...fields },
        package_id: fields.package_id,
        domains: props.cert.commonName,
      };
      store
        .dispatch("certificates/getCsrDetailsWithCert", props.cert.id, {
          package_id: fields.package_id,
        })
        .then((res) => {
          data.distinguished_name = { ...res };
          return store.dispatch("certificates/order", data);
        })
        .then(() => {
          root.$router.push("/ssl");
          store.dispatch("toasts/addToast", {
            variant: "info",
            message: root.$t("toasts.ssl-ordering-message"),
          });
        })
        .catch((e) => {
          const errors = e.request.response;
          for (let key in errors) {
            let message = errors[key];
            if (message.length > 0) {
              store.dispatch("toasts/addToast", {
                variant: "error",
                message: root.$t("toasts.ssl-order-error-message", { error: message }),
              });
            } else {
              store.dispatch("toasts/addToast", {
                variant: "error",
                message: root.$t("toasts.ssl-order-error-message", { error: "" }),
              });
            }
          }
        })
        .finally(() => (loading.value = false));
    };

    return {
      errors,
      fields,
      isSubmittable,
      loading,
      multipleDomainPackages,
      packageChange,
      singleDomainPackages,
      submit,
      wildcardDomainPackages,
    };
  },
};
</script>
<style lang="scss" scoped>
.ssl-package {
  width: 50%;
  display: inline-block;
}
</style>
